import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-film-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span
              className={`font-heading text-xl font-bold ${
                isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              80s电影网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'text-primary-500'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer rounded-lg ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium cursor-pointer transition-colors ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </div>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line"></i>
              </div>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}